import firebase from '../actions/firebase'

export default firebase.database()



/*import firebase from "firebase";
import  'firebase/storage'

const config = {
    apiKey: "AIzaSyDg387ctjssxidzYpOlBFovVyW8cemATcg",
    authDomain: "zametix-9a1ec.firebaseapp.com",
    databaseURL: "https://zametix-9a1ec.firebaseio.com",
    projectId: "zametix-9a1ec",
    storageBucket: "zametix-9a1ec.appspot.com",
    messagingSenderId: "458579689701"
};

firebase.initializeApp(config);
console.log(firebase.firestore)

const db = firebase.database()

//const storage2 = firebase.storage()

export default db;*/



// WEBPACK FOOTER //
// ./src/actions/database.js